import { openBlock as t, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(s, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      d: "M4.5 4.5h15v15h-15z"
    }, null, -1)
  ])]);
}
const d = { render: l };
export {
  d as default,
  l as render
};
